const url = process.env.REACT_APP_SERVER_INTERNAL_URL_BASE;

const apiConfig = {
	baseURL: url,
	headers: {
		post: {
			// can be common or any other method
			Accept: 'application/json',
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	},
};

export default apiConfig;
